@charset "UTF-8";

/* src/app/modules/user/components/personal-profile/personal-profile.component.scss */
.custom-ngselect .ng-select-container {
  min-height: 40px;
  border: 1px solid #ced4da;
  border-radius: 5px;
  display: flex;
  align-items: center;
}
.role-option {
  display: flex;
  align-items: center;
  padding: 8px;
}
.role-option:hover {
  background-color: #f4f4f4;
  border-radius: 5px;
}
.role-icon {
  margin-right: 8px;
  font-size: 18px;
  color: #007bff;
}
.selected-role {
  display: flex;
  align-items: center;
}
.selected-icon {
  margin-right: 8px;
  font-size: 18px;
  color: #28a745;
}
.custom-ngselect .ng-dropdown-panel {
  border-radius: 5px;
}
/*# sourceMappingURL=personal-profile.component.css.map */
